import { useLayoutEffect } from "react";

// =============================================================================
// usePageContainer(variant) — Pakiet 1 (2026-02-24)
//
// Pozwala pojedynczej stronie zadeklarować szerszy kontener bez modyfikacji
// MainLayout. Hook ustawia `data-container-variant` na <body>, co aktywuje
// reguły CSS w `index.css` (patrz sekcja „Container variants").
//
// Warianty:
//   - "standard" (domyślny; nie ustawia atrybutu) — max-w-6xl (1152 px) na lg+
//   - "wide"                                      — max-w-screen-2xl (1536 px) + większy padding
//   - "full"                                      — max-w-none (bez limitu)
//
// Cleanup przy odmontowaniu — kolejna strona zaczyna od czystego `standard`.
// =============================================================================
export const usePageContainer = (variant = "standard") => {
  useLayoutEffect(() => {
    if (variant === "standard") {
      // Brak atrybutu = default
      document.body.removeAttribute("data-container-variant");
      return () => {};
    }
    const prev = document.body.getAttribute("data-container-variant");
    document.body.setAttribute("data-container-variant", variant);
    return () => {
      if (prev) document.body.setAttribute("data-container-variant", prev);
      else document.body.removeAttribute("data-container-variant");
    };
  }, [variant]);
};
